export var ResourceEnum;
(function (ResourceEnum) {
    ResourceEnum["EVENTS"] = "events";
})(ResourceEnum || (ResourceEnum = {}));
